import { render, staticRenderFns } from "./BedEocTemplate.vue?vue&type=template&id=0e98e908&"
import script from "./BedEocTemplate.vue?vue&type=script&lang=js&"
export * from "./BedEocTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BedEocTemplate.vue?vue&type=style&index=0&id=0e98e908&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports